import Vue from "vue";
import router from '@/plugins/router'
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-6534299-1" }
}, router);